export class ShipmentActionCODAmount {
    
    public stopId : number;
    
    public amount : number|undefined = undefined;

    constructor(id : number, amount : number|undefined) {
        this.stopId = id;
        this.amount = amount;
    }
    
}

export class UpdateShipmentCODRequest {

    public amounts : ShipmentActionCODAmount[];

    public rowVersion : string;

}
